import Vue from 'vue'

import Cookies from 'js-cookie'
// import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import moment from 'moment'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import '@/assets/custom-theme/index.css'
import '@/assets/fonts/font.css'

// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/assets/styles/index.scss' // global css

// 数据字典

import App from './App'
import store from './store'
import router from './router'

import '@/assets/icons' // icon
import '@/permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import VueClipboard from 'vue-clipboard2'

// Vue.use(VueClipboard)
// Vue.use(checkPer)
// Vue.use(permission)
// Vue.use(dict)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// Vue.use(ElementUI, { size: Cookies.get('size') || 'medium', locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)

Vue.prototype.validForbid = function(value) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, '')
  return value
}
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.directive('defaultSelect', {
  componentUpdated(el, bindings, vnode) {
    // values v-model 绑定值
    // options 下拉选项
    // prop 对应 options 中 的 value 属性
    // defaultProp 默认值判断属性
    // defaultValue 默认值判断值
    const [values, options, prop, defaultProp, defaultValue] = bindings.value
    // 需要隐藏的标签索引
    // console.log(bindings.value)
    // console.log(options.find(op => op[prop]))
    const indexs = []
    const tempData = values.map(a => options.find(op => op[prop] == a))
    // console.log(tempData)
    tempData.forEach((a, index) => {
      // console.log(a[defaultProp])
      if (a[defaultProp] == defaultValue) indexs.push(index)
    })
    const dealStyle = function(tags) {
      tags.forEach((el, index) => {
        if (indexs.includes(index) && ![...el.classList].includes('select-tag-close-none')) {
          el.classList.add('none')
        }
      })
    }
    // 设置样式 隐藏close icon
    const tags = el.querySelectorAll('.el-tag__close')
    if (tags.length === 0) {
      // 初始化tags为空处理
      setTimeout(() => {
        const tagTemp = el.querySelectorAll('.el-tag__close')
        dealStyle(tagTemp)
      })
    } else {
      dealStyle(tags)
    }
  }
})
Vue.config.debuggerEnabled = false
Vue.config.devtools = false
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
